import React from 'react'
import ReactDOM from 'react-dom'

import {
  Notification,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { bemJoin } from '@app/lib/bem'
import { Alert } from '@app/lib/display/Alert/Alert'
import { useId } from '@app/lib/hooks/useId'

import './Notifications.scss'

const b = bemJoin('notifications')

type NotificationProps = {
  notification: Notification
  onDismiss: () => void
}

const NotificationAlert = ({ notification, onDismiss }: NotificationProps) => {
  const labelId = useId()
  const dismissHandler = () => onDismiss()

  if (notification.timeout) {
    setTimeout(dismissHandler, notification.timeout)
  }

  return (
    <Alert type={notification.type} onClick={dismissHandler}>
      <div role='alert' aria-labelledby={labelId}>
        <div id={labelId}>{notification.message}</div>
      </div>
    </Alert>
  )
}

export const Notifications = () => {
  const { notifications, dismissNotification } = useNotifications()

  return ReactDOM.createPortal(
    <div className={b()} aria-live='polite'>
      {notifications.map((notification) => {
        return (
          <NotificationAlert
            key={notification.id}
            notification={notification}
            onDismiss={() => dismissNotification(notification.id)}
          />
        )
      })}
    </div>,
    document.body
  )
}
